import { styled } from "@styles";
import { Card } from "react-bootstrap";

export const Wrapper = styled.div``;

export const OrderDetailCard = styled(Card)`
  margin-bottom: 1rem;
`;

export const OrderDetailHeader = styled(Card.Header)``;

export const OrderDetailBody = styled(Card.Body)``;

export const OrderDetail = styled.p`
  font-weight: 700;
  text-align: center;
  text-transform: uppercase;
  margin: 0;
`;

export const Td = styled.td`
`;

export const Discount = styled.td`
  color: #FF3398;
`;

export const TableItemRight = styled.td`
  text-align: right;
`;

export const TableItemRightDiscount = styled.td`
  text-align: right;
  color: #FF3398;
`;